import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import { Button, Card, Popconfirm, Space, Table } from 'antd';
import { get, keyBy, merge, values } from 'lodash';
import { columnTitles, TABLE } from './columns';
import TableUtils from '../../functions/TableUtils';
import ArticleApi from '../../functions/api/cms/ArticleApi';
import CountryApi from '../../functions/api/cms/CountryApi';

class ListArticle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listArticles: [],
      currentTotal: 0,
      currentDataSource: [],
      filteredInfo: TableUtils.getFilterFromUrl(),
      countries: [],
    };
  }

  async componentDidMount() {
    const countries = await CountryApi.index();
    await this.loadArticle();
    this.setState({ countries });
  }

  loadArticle = async () => {
    const listArticles = await ArticleApi.index();

    this.setState({
      listArticles,
      currentTotal: listArticles.length,
      currentDataSource: listArticles,
    });
  };

  renderPublishedStatus = (cell, row) => {
    if (true === row.article.published) {
      return 'Hiện';
    }

    return 'Ẩn';
  };

  handleInsertButtonClick = () => {
    this.props.history.push('/article/add-article');
  };

  handlePublishOrUnPublish = async (id, status) => {
    if (status) {
      await ArticleApi.publish(id);
    } else {
      await ArticleApi.unPublish(id);
    }

    await this.loadArticle();
  };

  getCountryFilter = (dataIndex) => {
    const { countries } = this.state;

    const filters = countries.map((item) => {
      return {
        text: item.short_name,
        value: item.code,
      };
    });

    filters.push({
      text: '(trống)',
      value: null,
    });

    return {
      filters,
      onFilter: (value, record) => get(record, dataIndex) === value,
    };
  };

  tableSourceDidChange = (
    pagination,
    filters,
    sorter,
    { currentDataSource }
  ) => {
    TableUtils.pushFilterToUrl(filters);
    this.setState({
      currentTotal: currentDataSource.length,
      currentDataSource: currentDataSource,
      filteredInfo: filters,
    });
  };

  getColumnConfig = (filteredInfo) => {
    const columnConfigs = [
      {
        dataIndex: 'title',
        key: 'title',
        filteredValue: filteredInfo.title || null,
        ...TableUtils.getColumnSearchProps('title'),
      },
      {
        dataIndex: 'content',
        key: 'content',
      },
      {
        dataIndex: 'slug',
        key: 'slug',
        filteredValue: filteredInfo.slug || null,
        ...TableUtils.getColumnSearchProps('slug'),
      },
      {
        dataIndex: 'language',
        key: 'language',
        ...this.getCountryFilter('language'),
        filteredValue: filteredInfo.language || null,
      },
      {
        dataIndex: 'published',
        key: 'published',
        filteredValue: filteredInfo.published || null,
        render: this.renderPublishedStatus,
      },
      {
        title: null,
        key: 'delete',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/article/edit-article/${record.id}/${record.language}`
                  )
                }
              >
                <i className="fas fa-edit" />
              </Button>
              {record.article.published && (
                <Popconfirm
                  title="Bạn chắc chắn muốn ẩn bài viết này?"
                  onConfirm={() =>
                    this.handlePublishOrUnPublish(record.article.id, false)
                  }
                >
                  <Button size="small" danger>
                    <i className="fas fa-trash" />
                  </Button>
                </Popconfirm>
              )}
              {false === record.article.published && (
                <Popconfirm
                  title="Bạn chắc chắn muốn hiện bài viết này?"
                  onConfirm={() =>
                    this.handlePublishOrUnPublish(record.article.id, true)
                  }
                >
                  <Button size="small">
                    <i className="fas fa-plus-square" />
                  </Button>
                </Popconfirm>
              )}
            </Space>
          );
        },
      },
    ];

    const titles = columnTitles.filter((t) => t.hideOn !== TABLE.BACKEND);
    const mergeKey = 'dataIndex';

    return values(
      merge(keyBy(titles, mergeKey), keyBy(columnConfigs, mergeKey))
    );
  };

  render() {
    const { listArticles, currentTotal, filteredInfo } = this.state;

    const columns = this.getColumnConfig(filteredInfo);

    return (
      <>
        <h1>Bài viết</h1>
        <Card className="mb-2" size="small">
          <Space>
            {MyUtil.hasPermission('/article', 'add') && (
              <Button onClick={this.handleInsertButtonClick} type="primary">
                Thêm bài viết
              </Button>
            )}
          </Space>
        </Card>
        <Table
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={listArticles}
          scroll={{ x: 'max-content' }}
          onChange={this.tableSourceDidChange}
          title={() => `Tổng số: ${currentTotal}`}
        />
      </>
    );
  }
}

export default withRouter(ListArticle);
